import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import {ExpandMoreOutlined} from "@mui/icons-material";
import {PD_LG, PD_SM} from "@/shared/dimens";
import {FaqSectionData} from "../../types";

export function FaqSection(props: { data: FaqSectionData }): ReactElement {
  return <SectionContainer>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6, lineHeight: 1.7}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.faqs.map((faq, i) =>
        <Accordion key={i} disableGutters style={{
          borderRadius: PD_SM,
          overflow: "hidden",
          border: "1px solid rgba(0,0,0,0.08)",
        }}>
          <AccordionSummary expandIcon={<ExpandMoreOutlined/>} style={{padding: `0 ${PD_LG}px`, minHeight: 64}}>
            <Typography style={{fontWeight: "600", padding: `${PD_SM}px 0`}}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{padding: `0 ${PD_LG}px ${PD_LG}px`}}>
            <Typography style={{opacity: 0.7, lineHeight: 1.8}}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </StyledBoxColumn>
  </SectionContainer>;
}
